import { supabase } from '../lib/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;

interface CalendarSyncResult {
  success: boolean;
  created: number;
  updated: number;
  skipped: number;
  errors: string[];
}

export class CalendarSyncService {
  static async syncReleases(): Promise<CalendarSyncResult> {
    try {
      console.log('📅 Calling calendar sync edge function...');
      
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        throw new Error('Not authenticated');
      }

      const response = await fetch(`${supabaseUrl}/functions/v1/sync-calendar`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Edge function failed: ${response.statusText} - ${errorText}`);
      }

      const result: CalendarSyncResult = await response.json();
      console.log('📊 Sync result:', result);
      return result;
    } catch (error) {
      console.error('Calendar sync error:', error);
      return {
        success: false,
        created: 0,
        updated: 0,
        skipped: 0,
        errors: [String(error)]
      };
    }
  }

  static async testConnection(): Promise<boolean> {
    try {
      console.log('🧪 Testing calendar connection (no sync)...');
      
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        throw new Error('Not authenticated');
      }

      const response = await fetch(`${supabaseUrl}/functions/v1/sync-calendar?test=true`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Test failed: ${response.statusText} - ${errorText}`);
      }

      const result = await response.json();
      console.log('✅ Calendar connection test successful:', result);
      return result.success;
    } catch (error) {
      console.error('❌ Calendar connection test failed:', error);
      return false;
    }
  }
}
